import onboarding from 'assets/images/onboarding.png'
import SessionConst from 'constants/SessionConst'
import React, { Component } from 'react'
import { IconContext } from "react-icons"
import { FaExclamationCircle, FaLock, FaLockOpen } from 'react-icons/fa'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { isArrayNotEmpty, isObjectEmpty, removeHotelInfoFromSession, removeHotelOnboardingStatusFromSession, removeLockStatusFromSession } from 'utilities/JSUtil'
import * as FormConst from '../../constants/FormConst'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import HotelHistoryService from '../../services/HotelHistoryService'
import { getSessionItem } from '../../utilities/SessionHelper'
import Button from '../atoms/Button/Button'
import FormModal from '../organisms/FormModal/FormModal'
import './SearchHotelHistory.scss'
import './SearchHotel.scss'
import Table from '../molecules/Table/Table'
import ReactJson from 'react-json-view'
import Pagination from '../organisms/Pagination/Pagination'

class SearchHotelHistory extends Component {

    statusList = Object.keys(FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS)
    displayStatusList = Object.keys(FormConst.HOTEL_ONBOARDING_DISPLAY_STATUS_TO_STATUS)

    constructor(props) {
        super(props)
        removeHotelInfoFromSession()
        removeLockStatusFromSession()
        let user = getSessionItem(SessionConst.USER)
    
        if (!user || isObjectEmpty(user)) {
          this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            sessionData: null,
            hotelCode: this.props.location?.state?.hotelCode,
            status: this.statusList,
            searchHotelHistoryList: [],
            historyRecordDetails: {},
            searchKeyHotelCode: '',
            searchKeyOnboardingStatus: '',
            errorMessage: undefined,
            currentUser: getSessionItem(SessionConst.USER).username,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            isUpdateLock: false,
            editIndex: -1,
            total: 0,
            limit: 10
        }

        this.searchHotelHistorySummary = this.searchHotelHistorySummary.bind(this)
    }

    handleHotelCodeChange = (event) => {
        this.setState({
            hotelCode: event.target.value?.trim().toUpperCase()
        })
    }

    async componentDidMount() {
        if (!this.state.hotelCode) {
            this.setState({ searchHotelHistoryList: [], isLoading: false })
            return
        }

        await HotelHistoryService.searchHotelOnboardingHistorySummary(this.state.hotelCode, 0, this.state.limit)
            .then(historyResponse => {
                const historyList = historyResponse.hotelOnboardingHistoryItems.map((entry, index) => {
                    return {
                        index: index,
                        ...entry
                    }
                })

                if (isArrayNotEmpty(historyList)) {
                    this.setState({ 
                        searchHotelHistoryList: historyList, 
                        isLoading: false, 
                        errorMessage: undefined,
                        total: historyResponse.metaData.total
                    })
                } else {
                    this.setState({ searchHotelHistoryList: [], isLoading: false })
                }
            }).catch(error => {
                this.setState({ searchHotelHistoryList: [], isLoading: false })
            })
    }

    searchHotelHistorySummary = async (offset) => {
        // If there is no hotel code, throw error
        if (!this.state.hotelCode) {
            this.setState({ errorMessage: 'Please enter a hotel code' })
            return
        }

        HotelHistoryService.searchHotelOnboardingHistorySummary(this.state.hotelCode, offset, this.state.limit)
            .then(historyResponse => {
                const historyList = historyResponse.hotelOnboardingHistoryItems.map((entry, index) => {
                    return {
                        index: index,
                        ...entry
                    }
                })

                if (isArrayNotEmpty(historyList)) {
                    this.setState({ 
                        searchHotelHistoryList: historyList, 
                        isLoading: false, 
                        errorMessage: undefined,
                        total: historyResponse.metaData.total
                    })
                } else {
                    this.setState({ searchHotelHistoryList: [], isLoading: false })
                }
            }).catch(error => {
                this.setState({ searchHotelHistoryList: [], isLoading: false, errorMessage: undefined })
            })

        this.setState({ isLoading: true })
    }

    searchHistoryRecordDetails = (hotelOnboardingId, event) => {

        HotelHistoryService.getHotelOnboardingHistoryDetails(hotelOnboardingId, 0, this.state.limit)
            .then(historyResponse => {
                if (historyResponse?.hotelOnboardingHistoryItems?.hotelOnboardingItems.length > 1) {
                    this.redirectToHistoryDetailsPage(historyResponse, hotelOnboardingId)
                }

                this.setState({ historyRecordDetails: historyResponse, isLoading: false, errorMessage: undefined })
            }).catch(error => {
                this.setState({ historyRecordDetails: {}, isLoading: false, errorMessage: undefined })
            })

        this.setState({ isLoading: true })
    }

    redirectToUpdateOnboarding = (onboardingEntry, action) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_UPDATE_ONBOARDING_PAGE,
            state: {
                hotelCode: onboardingEntry.hotelCode,
                onboardingStatus: onboardingEntry,
                action: action
            }
        })
    }

    redirectToSearch = () => {
        this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    handleErrorModalCancel = () => {
        this.setState({ errorMessage: undefined })
    }

    redirectToHistoryDetailsPage = (historyRecordDetails, hotelOnboardingId) => {
        this.props.history.push({
            pathname: RouteConst.ROUTE_HISTORY_DETAILS_PAGE,
            state: {
                hotelCode: historyRecordDetails.hotelOnboardingHistoryItems.hotelCode,
                historyRecords: historyRecordDetails.hotelOnboardingHistoryItems.hotelOnboardingItems,
                hotelOnboardingId: hotelOnboardingId,
                total: historyRecordDetails.metaData.total
            }
        })
    }

    render() {
        const searchHotelLabel = <label id='search-page-hotel-code-label'><b>Hotel Code</b></label>
        const searchHotelInput = <input id='search-page-hotel-code-input' className='search-page-hotel-code-input' type='text' onChange={this.handleHotelCodeChange} autoComplete='off' />
        const actionButton = (
            <div className='action-button'>
                <Button id='search-page-search-button' name='History Search' role='action' onClick={() => this.searchHotelHistorySummary(0)} />
            </div>
        )
        let inputRow = [searchHotelLabel, searchHotelInput, actionButton]
        let searchHotelFormDataSingleRow = [inputRow]


        return (

            <div className='search-hotel-history-list-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                <div className='search-hotel-list'>
                    <Button id='search-page-button-top' name='Go to search page' className='search-button' onClick={this.redirectToSearch} />
                    <p id='search-page-info' className='search-hotel-list-header'>Search Onboarding History for an Hotel:</p>
                    <Table id='search-page-table-layout' borderless className='search-hotel-form-table-single-row' data={searchHotelFormDataSingleRow}></Table>

                    <table
                        id='search-page-application-list-table'
                        className='table table-striped search-hotel-list-table'
                    >
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Hotel Code</th>
                                <th>Requestor</th>
                                <th>Status</th>
                                <th>Type</th>
                                <th>Expand</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.searchHotelHistoryList)
                                    ? (
                                        this.state.searchHotelHistoryList.map((historyRecord, index) =>
                                            <>
                                                <tr key={index} className="accordion-toggle collapsed" id={`accordion${index}`} data-toggle="collapse"
                                                    data-parent={`#accordion${index}`} href={`#collapse${index}`}
                                                    onClick={(e) => this.searchHistoryRecordDetails(historyRecord.hotelOnboardingId, e)}>
                                                    <td>{historyRecord.eventDateTime}</td>
                                                    <td>{historyRecord.hotelCode}</td>
                                                    <td>{historyRecord.requestor}</td>
                                                    <td>{historyRecord.status}</td>
                                                    <td>{historyRecord.type}</td>
                                                    <td className="expand-button"></td>
                                                </tr>

                                                {
                                                    <tr key={`${index}-details`} className="hide-table-padding">
                                                        <td colSpan="6">
                                                            <div id={`collapse${index}`} className="collapse in p-3">
                                                                {!isObjectEmpty(this.state.historyRecordDetails)
                                                                    && <ReactJson src={this.state.historyRecordDetails} />}
                                                            </div>
                                                        </td>
                                                    </tr>

                                                }
                                            </>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={6} className='text-center'>No records found</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>

                    <Pagination 
                        total={this.state.total}
                        pageLimit={this.state.limit}
                        getData={this.searchHotelHistorySummary} />

                    <Button
                        id='search-page-search-page-button-bottom'
                        name='Go to search page'
                        className='search-button'
                        onClick={this.redirectToSearch} />

                    <FormModal
                        id='hotel-info-page-save-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                        hotelInfo={this.state.hotelInfo}
                        body={<h6>{this.state.loadingMessage}</h6>}
                        show={this.state.isLoading}
                        isLoadingIndicator />
                    <FormModal
                        id='search-page-error-modal'
                        title='Error'
                        body={
                            <>
                                <p>{this.state.errorMessage}</p>
                                <p>Tracking id:</p>
                                <p className='text-bold'>{getSessionItem(SessionConst.TRACKING_ID)}</p>
                            </>
                        }
                        hotelInfo={this.state.hotelInfo}
                        show={!!this.state.errorMessage}
                        cancel={this.handleErrorModalCancel} />
                </div>
            </div>
        )
    }

}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        lockStatusResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        acquireUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.ACQUIRE_USER, { hotelCode: hotelCode })),
        resetUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_ADMIN_PAGE_NAME, actionTypes.ASYNC_ACTIONS.RESET_USER, { hotelCode: hotelCode }))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchHotelHistory))